"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.isSiteExternal = isSiteExternal;
var _externalSiteConstants = require("../constants/externalSiteConstants");
var _window = _interopRequireDefault(require("../shared/window"));
function isSiteExternal() {
  var url = _window["default"].location.href;
  return url.includes(_externalSiteConstants.EXTERNAL_PASSPORT_APP_DOMAIN_NAME);
}
var _default = exports["default"] = isSiteExternal;
//# sourceMappingURL=isSiteExternal.js.map